define([
    "./monitoringNodeCommandsModule"
], function (module) {
    "use strict";

    return module.service("nodeCommandMonitorableStart", ["monitorableService", function (monitorableService) {
        return function (selection, context) {
            return monitorableService.startMonitorables(selection.map(function (nodeIdentifier) {
                return nodeIdentifier.id;
            })).then(function () {
                return context.refilter();
            });
        };
    }]);
});